import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import ResourceBook from "./ResourcesUtils/ResourceBook";
import ResourceCourse from "./ResourcesUtils/ResourceCourse";
import ResourceOther from "./ResourcesUtils/ResourceOther";
import ResourceYoutubeLink from "./ResourcesUtils/ResourceYoutubeLink";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const getEmptyResource = () => {
  return {
    name: "",
    content: "",
    books: [],
    courses: [],
    youtubeLinks: [],
    others: [],
  };
};

export default function ResourcesForm() {
  const [resource, setResource] = useState(getEmptyResource());
  const image = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // const controller = new AbortController();
    const id = window.location.pathname.split("/").pop();
    axios
      .get(`${BASE_URL}/resources/single/${id}`)
      .then((res) => {
        const resourceDetails = res.data.resource;
        // Handle not to store key imgUrl in state
        // delete event.imgUrl;
        const books = JSON.parse(resourceDetails.books);
        const courses = JSON.parse(resourceDetails.courses);
        const youtubeLinks = JSON.parse(resourceDetails.youtubeLinks);
        const others = JSON.parse(resourceDetails.others);
        setResource({
          _id: resourceDetails._id,
          name: resourceDetails.name,
          content: resourceDetails.content,
          books: books,
          courses: courses,
          youtubeLinks: youtubeLinks,
          others: others,
          imgUrl: resourceDetails.imgUrl,
        });
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  const handleChange = (e) => {
    setResource({
      ...resource,
      [e.target.name]: e.target.value,
    });
  };

  const handleResourceUpdate = async (e) => {
    let message = "";
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("UnAuthorized");
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const formData = new FormData();
      if (image.current.files[0]) {
        formData.append("image", image.current.files[0]);
        const response = await axios.put(
          `${BASE_URL}/resources/single/image/${resource._id}`,
          formData,
          config
        );
        if (response.data.success === true) {
          message = response.data.message;
        } else {
          throw new Error(response.data.message);
        }
      }
      const newFormData = new FormData();
      newFormData.append("name", resource.name);
      newFormData.append("content", resource.content);
      newFormData.append("books", JSON.stringify(resource.books));
      newFormData.append("courses", JSON.stringify(resource.courses));
      newFormData.append("youtubeLinks", JSON.stringify(resource.youtubeLinks));
      newFormData.append("others", JSON.stringify(resource.others));
      console.log(`${BASE_URL}/resources/single/${resource._id}`);
      const response = await axios.put(
        `${BASE_URL}/resources/single/${resource._id}`,
        newFormData,
        config
      );
      if (response.data.success === true) {
        message += response.data.message;
        alert(message);
        navigate("/admin/resources");
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleGoBack = () => {
    navigate("/admin/resources");
  };

  // Method called when the user clicks the "Add new book" button
  const handleAddBook = (e) => {
    e.preventDefault();
    setResource({
      ...resource,
      books: [
        ...resource.books,
        {
          name: "",
        },
      ],
    });
  };

  // Method called when the user clicks the "Add new course" button
  const handleAddCourse = (e) => {
    e.preventDefault();
    setResource({
      ...resource,
      courses: [
        ...resource.courses,
        {
          name: "",
          link: "",
        },
      ],
    });
  };

  // Method called when the user clicks the "Add new youtube link" button
  const handleAddYoutubeLink = (e) => {
    e.preventDefault();
    setResource({
      ...resource,
      youtubeLinks: [
        ...resource.youtubeLinks,
        {
          link: "",
        },
      ],
    });
  };

  // Method called when the user clicks the "Add new other" button
  const handleAddOther = (e) => {
    e.preventDefault();
    setResource({
      ...resource,
      others: [
        ...resource.others,
        {
          name: "",
          link: "",
        },
      ],
    });
  };

  // Handle the change of the book details
  const addBook = (index, book) => {
    const books = [...resource.books];
    books[index] = book;
    setResource({
      ...resource,
      books,
    });
  };

  // Handle the change of the course details
  const addCourse = (index, course) => {
    const courses = [...resource.courses];
    courses[index] = course;
    setResource({
      ...resource,
      courses,
    });
  };

  // Handle the change of the youtube link details
  const addYoutubeLink = (index, link) => {
    const youtubeLinks = [...resource.youtubeLinks];
    youtubeLinks[index] = link;
    setResource({
      ...resource,
      youtubeLinks,
    });
  };

  // Handle the change of the other details
  const addOther = (index, other) => {
    const others = [...resource.others];
    others[index] = other;
    setResource({
      ...resource,
      others,
    });
  };

  // Method called when Remove Book button is clicked
  const handleRemoveBook = (index) => {
    setResource({
      ...resource,
      books: resource.books.filter((book, i) => i !== index),
    });
  };

  // Method called when Remove Course button is clicked
  const handleRemoveCourse = (index) => {
    setResource({
      ...resource,
      courses: resource.courses.filter((course, i) => i !== index),
    });
  };

  // Method called when Remove Youtube Link button is clicked
  const handleRemoveYoutubeLink = (index) => {
    setResource({
      ...resource,
      youtubeLinks: resource.youtubeLinks.filter((link, i) => i !== index),
    });
  };

  // Method called when Remove Other button is clicked
  const handleRemoveOther = (index) => {
    setResource({
      ...resource,
      others: resource.others.filter((other, i) => i !== index),
    });
  };

  return (
    <div className="py-3 container is-fluid">
      <form encType="multipart/form-data">
        <div className="columns is-centered">
          <div className="column is-two-thirds">
            <div className="field">
              <label className="label">Resource Name</label>
              <div className="control">
                <input
                  autoFocus
                  name="name"
                  className="input"
                  value={resource.name}
                  type="text"
                  placeholder="Name"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Present Image</label>
              <div className="control">
                <figure className="image is-square">
                  <img
                    src={resource.imgUrl}
                    alt="Resource display"
                    style={{
                      width: "100%",
                      objectFit: "scale-down",
                    }}
                  />
                </figure>
              </div>
            </div>

            <div className="field">
              <label className="label">Resource Image</label>
              <div className="control">
                <input name="image" className="input" type="file" ref={image} />
              </div>
            </div>

            <div className="field">
              <label className="label">Resource Content</label>
              <textarea
                name="content"
                className="textarea"
                value={resource.content}
                placeholder="Resource content"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="field">
              <label className="label">Books</label>
              <div className="control">
                {resource.books.map((book, index) => (
                  <ResourceBook
                    book={book}
                    key={index}
                    index={index}
                    handleRemoveBook={handleRemoveBook}
                    addBook={addBook}
                  />
                ))}
                <button
                  className="button is-rounded is-small is-info"
                  onClick={handleAddBook}
                >
                  Add New Book
                </button>
              </div>
            </div>

            <div className="field">
              <label className="label">Courses</label>
              <div className="control">
                {resource.courses.map((course, index) => (
                  <ResourceCourse
                    course={course}
                    key={index}
                    index={index}
                    handleRemoveCourse={handleRemoveCourse}
                    addCourse={addCourse}
                  />
                ))}
                <button
                  className="button is-rounded is-info is-small"
                  onClick={handleAddCourse}
                >
                  Add New Course
                </button>
              </div>
            </div>

            <div className="field">
              <label className="label">Youtube Links</label>
              <div className="control">
                {resource.youtubeLinks.map((link, index) => (
                  <ResourceYoutubeLink
                    youtubeLink={link}
                    key={index}
                    index={index}
                    handleRemoveYoutubeLink={handleRemoveYoutubeLink}
                    addYoutubeLink={addYoutubeLink}
                  />
                ))}
                <button
                  className="button is-rounded is-info is-small"
                  onClick={handleAddYoutubeLink}
                >
                  New Youtube Link
                </button>
              </div>
            </div>

            <div className="field">
              <label className="label">Others</label>
              <div className="control">
                {resource.others.map((other, index) => (
                  <ResourceOther
                    other={other}
                    key={index}
                    index={index}
                    handleRemoveOther={handleRemoveOther}
                    addOther={addOther}
                  />
                ))}
                <button
                  className="button is-rounded is-info is-small"
                  onClick={handleAddOther}
                >
                  New Other
                </button>
              </div>
            </div>

            <div className="field is-grouped">
              <div className="control">
                <button
                  className="button is-link is-success"
                  onClick={handleResourceUpdate}
                >
                  Save Changes
                </button>
              </div>
              <div className="control">
                <button
                  className="button is-link is-light is-info"
                  onClick={handleGoBack}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
